
export const getIntValue = (value) => {
    if (value == '') return 0;
    return !isNaN(value) ? parseInt(value) : 0;
};

export const sumCost = (costYears) => {
    return costYears.reduce((a, b) => getIntValue(a) + getIntValue(b), 0);
};

export const formatNumber = (value) => {
    if (value == '') return 0;
    
    return !isNaN(value) ? value.toLocaleString() : 0;
}